import React from 'react';
import { Box } from '@styleseat/ui';
import { BrandColor } from '@styleseat/brand';
import { BodyText, UnderlineLink } from '../../../ui';

type GeolocationAuthorizationSubtextParams = {
  onLinkPress: () => void,
  textAlign?: 'left' | 'center',
  appearance?: 'small' | 'medium',
};

export const GeolocationAuthorizationSubtext: React.FC<GeolocationAuthorizationSubtextParams> = ({
  onLinkPress,
  textAlign = 'center',
  appearance = 'medium',
}) => (
  <Box testID="ttp-checkout-geolocation-authorization-subtext">
    <BodyText appearance={appearance} textAlign={textAlign} color={BrandColor.Metal}>
      Tap to Pay on iPhone requires permission to use your
    </BodyText>
    <BodyText appearance={appearance} textAlign={textAlign} color={BrandColor.Metal}>
      location. Adjust your{' '}
      <UnderlineLink
        onPress={onLinkPress}
        underlineVerticalOffset={2}
        underlineHeight={1}
        textAppearance={appearance}
        tone="slate"
        testID="ttp-checkout-geolocation-authorization-subtext-link"
      >
        StyleSeat location permissions here
      </UnderlineLink>
    </BodyText>
  </Box>
);
